// extracted by mini-css-extract-plugin
export default {"container":"login_container__JyuHl","card":"login_card__Oqd3d","imageBlock":"login_imageBlock__RA4SI"};